import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/hz";
import { HZ_APP_URL } from "@/lib/api";

export const Footer = () => (
  <footer className="bg-slate-950 text-slate-400" data-testid="site-footer">
    <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <div className="font-heading text-xl font-extrabold text-white">Handy<span className="text-orange-500">Zoom</span></div>
        <p className="mt-3 max-w-sm text-sm leading-relaxed">Profesionales verificados de fontanería, electricidad, carpintería, pintura, suelos, manitas y mantenimiento. Presupuestos, facturas con IVA y pagos seguros en un solo sitio.</p>
      </div>
      <div className="space-y-2 text-sm">
        <div className="font-semibold text-white">Atención al cliente</div>
        <a className="block hover:text-white" href={`tel:${CONTACT.phone}`}>Tel. {CONTACT.phoneDisplay}</a>
        <a className="block hover:text-white" href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer">WhatsApp {CONTACT.whatsappDisplay}</a>
        <a className="block hover:text-white" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
      </div>
      <div className="space-y-2 text-sm">
        <div className="font-semibold text-white">Enlaces</div>
        <Link className="block hover:text-white" to="/profesionales">Profesionales</Link>
        <Link className="block hover:text-white" to="/register?role=profesional">Únete como profesional</Link>
        <Link className="block hover:text-white" to="/soporte">Preguntas frecuentes</Link>
        <a className="block hover:text-white" href={HZ_APP_URL} target="_blank" rel="noreferrer" data-testid="footer-open-app">Abrir la app HandyZoom</a>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs">© {new Date().getFullYear()} HandyZoom · Pagos seguros con Stripe</div>
  </footer>
);

export const WhatsAppFab = () => (
  <a href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer" data-testid="whatsapp-fab" aria-label="WhatsApp"
    className="fixed bottom-5 right-5 z-50 grid size-14 place-items-center rounded-full bg-emerald-500 text-white shadow-lg transition-transform hover:scale-105">
    <MessageCircle className="size-7" />
  </a>
);
